<template>
  <div class="page-column">
    <Header/>
    <BasketballPaylerDetail />
    <Footer/>
  </div>
</template>

<script>
import Header from '@district/components/common/MatchHeader.vue'
import Footer from '@district/components/common/Footer'
import BasketballPaylerDetail from  '@comm/components/match/basketball/components/BasketballPaylerDetail.vue'

export default {
  components: {
    Header,
    BasketballPaylerDetail,
    Footer
  },
  data () {
    return {
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  mounted () {
    this.$bus.$emit('handleMenu',0,2)
  },
  methods: {
  },
  
}
</script>
<style lang="scss" scoped>
.page-column {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/district/views/project/components/BasketallPlayer.vue